// extracted by mini-css-extract-plugin
export default {"container":"yM-z","dimension":"zM-z","dimensionLabels":"AM-z"};